import { Box, IconButton, TextField } from "@mui/material";
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from "@mui/icons-material";
import { tablePaginationStyles } from "./TablePagination.styles";

type TTablePagination = {
    currentPage: number;
    totalPages: number;
    pageValue: number | string;
    onPageChange: (page: number) => void;
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleOnBlur: () => void;
    handleOnKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    inputRef: any;
};

const TablePagination = ({
    currentPage,
    totalPages,
    pageValue,
    onPageChange,
    handleInputChange,
    handleOnBlur,
    handleOnKeyDown,
    inputRef,
}: TTablePagination): JSX.Element => {
    const classes = tablePaginationStyles();
    return (
        <Box className={classes.paginationWrapper}>
            <IconButton disabled={currentPage <= 1} onClick={() => onPageChange(1)}>
                <FirstPage />
            </IconButton>
            <IconButton disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>
                <KeyboardArrowLeft />
            </IconButton>

            <TextField
                id="pagination-input"
                type="number"
                autoComplete="off"
                variant="outlined"
                size="small"
                value={pageValue}
                className={classes.paginationInputField}
                onChange={handleInputChange}
                onBlur={handleOnBlur}
                onKeyDown={handleOnKeyDown}
                inputProps={{
                    pattern: "[0-9]*",
                    min: 1,
                    max: totalPages,
                    style: {
                        textAlign: "center",
                    },
                }}
                InputProps={{
                    style: {
                        width: 56,
                        height: 26,
                        margin: "auto",
                        fontSize: 14,
                    },
                }}
                inputRef={inputRef}
            />
            <span style={{ margin: "auto", paddingLeft: "8px" }}>of {totalPages}</span>

            <IconButton disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>
                <KeyboardArrowRight />
            </IconButton>
            <IconButton disabled={currentPage >= totalPages} onClick={() => onPageChange(totalPages)}>
                <LastPage />
            </IconButton>
        </Box>
    );
};

export default TablePagination;
